import { apiClient } from '@/lib/api/client';
import { endpoints } from '@/lib/api/endpoints';
import { parseContract } from '@/lib/api/parse';

import { toListQuery } from './filters';
import { deviceActivityListResponseSchema } from './schemas';
import type { DeviceActivityListParams, DeviceActivityListResponse } from './types';

/** Sort + filters → the list's wire params, defaults included. The export sends the same, so the
 *  file comes out with the rows and order on screen, sorted or not (ADO 120974). */
export function deviceActivityRequestQuery(
  params: Omit<DeviceActivityListParams, 'page' | 'limit'>,
) {
  const { sortBy = 'purchaseDate', sortOrder = 'desc', ...filters } = params;
  return { sortBy, sortOrder: sortOrder.toUpperCase(), ...toListQuery(filters) };
}

/** Paginated/sorted/searchable Device Activity report — one row per owned subscribable Device unit.
 *  Defaults to `purchaseDate DESC` (AC: newest purchase first). The stub's server-side default is
 *  `createdDate DESC`, which we never rely on because the FE always sends `sortBy` explicitly.
 *  `sortOrder` is uppercased for the DTO's `ASC`/`DESC` enum. */
export async function listDeviceActivity(
  params: DeviceActivityListParams,
): Promise<DeviceActivityListResponse> {
  const { page, limit, ...rest } = params;
  const { data, meta } = await apiClient.getList(endpoints.reports.deviceActivity, {
    params: { page, limit, ...deviceActivityRequestQuery(rest) },
  });
  return parseContract(
    deviceActivityListResponseSchema,
    { data, meta },
    endpoints.reports.deviceActivity,
  );
}
